import React, { PropTypes } from 'react';
import RenderField from '../../../FormTemplate/InputControl';
import { Field } from 'redux-form';
import { Button, Table } from 'react-bootstrap';
import Select from './../../../FormTemplate/Select';

class FormExpenseList extends React.Component {
   render() {
      const { fields, expenseAccounts } = this.props;
      return (
         <div>
            <Table>
               <thead>
               <tr>
                  <th>Expense Accounts</th>
                  <th>Amount</th>
                  <th>##</th>
               </tr>
               </thead>
               <tbody>
               {fields.map((item, index) =>
                  <tr key={index} >
                     <td className="col-md-6" >
                        <Field
                           name={`${item}.account_id`}
                           allowEmpty={true}
                           options={expenseAccounts}
                           component={Select} />
                     </td>
                     <td>
                        <Field
                           name={`${item}.amount`}
                           type="number"
                           component={RenderField} />
                     </td>
                     <td>
                        <Button onClick={() => fields.remove(index)} >remove</Button>
                     </td>
                  </tr>
               )}
               </tbody>
            </Table>
            <Button onClick={() => fields.push({})} >Add Another Expense</Button>
         </div>
      );
   }
}

FormExpenseList.propTypes = {
   fields: PropTypes.object,
   expenseAccounts: PropTypes.array
};

export default FormExpenseList;



/** WEBPACK FOOTER **
 ** ./src/components/InvoiceManagement/Expense/FormHelper/FormExpenseList.js
 **/